import { Card, CardContent } from '@/components/ui/card'

const data = [
  { name: 'Aéras', value: 45 },
  { name: 'Criador', value: 80 },
  { name: 'Formato', value: 100 },
  { name: 'Trend', value: 30 },
  { name: 'Estética', value: 70 },
  { name: 'Assunto', value: 25 }
]

const maxValue = Math.max(...data.map(item => item.value))

export function PinnedExpressionsChart() {
  return (
    <Card className="bg-white h-fit">
      <CardContent className="pt-6 pb-6">
        <div className="flex items-start justify-between gap-8">
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Expressões Pinadas</h3>
              <p className="text-sm text-gray-600 max-w-[250px]">
                Veja ao lado a quantidade por categoria.
              </p>
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900">3.210</p>
              <p className="text-sm text-gray-600">expressões totais</p>
            </div>
          </div>
          <div className="flex-1">
            <div className="flex items-end justify-center gap-3 h-48">
              {data.map((item, index) => (
                <div key={index} className="flex flex-col items-center h-full justify-end">
                  <div 
                    className="w-12 bg-[#F2FF00] rounded-t-[10px]"
                    style={{ 
                      height: `${(item.value / maxValue) * 100}%`,
                    }}
                  />
                  <p className="text-[10px] text-gray-600 mt-2 text-center w-12">{item.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
